import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/services/authentication/authentication.service';

@Injectable()
export class AuthGuardService {

    constructor(private router: Router, private authenticationService: AuthenticationService) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        this.authenticationService.redirectUrl = state.url;

        return this.authenticationService.isLoggedIn()
                   .pipe(
                       map((isLoggedIn) => {
                               if (state.url !== '/login' && !isLoggedIn) {
                                   (async () => await this.router.navigate(['/login']))();
                                   return false;
                               }

                               return true;
                           },
                       ),
                   );
    }
}

